import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default ({status}) => {
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(""); 


  const getRole = () => {
    axios({
      method: "get",
      url: "/roles",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: item.id,
            label: item.name,
          })
        );
        setRoles(tmp); 
      })
      .catch(() => {
        console.error("алдаа гарлаа.");
      });
  };

  useEffect(() => {
    getRole(); 
  }, []);

  return [
    {
      label: 'Овог',
      name: 'lastname',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Нэр',
      name: 'firstname',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Утас',
      name: 'mobile',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Майл',
      name: 'email',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Үүрэг',
      name: 'roleid',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
        options: roles.map(role => ({value: role.value, label: role.label}))
      },
      type: 'select',
    },
    {
      label: 'Төлөв',
      name: 'status',
      className: 'col-span-12 mb-0',
      type: 'select',
      inputProps: {
        options: status ,
      },
      // inputProps: {
      //   className: 'w-full',
      //   options: [
      //     {value: 1, label: 'Ивэхитэй'},
      //     {value: 0, label: 'Ивэвхигүй'}
      //   ],
      //   },
    },
  ];
};
